const VirtualCreditCardDetail = (state) => state.VirtualCreditCardDetail

export default {
  VirtualCreditCardDetail
}
